/** Anzeigeformate der Trainingsseite (F-34). */
import type { PlanSatz, PlanUebung } from '@/domain/training/typen';

export function satzText(s: PlanSatz): string {
  const teile: string[] = [];
  if (s.dauerSek) teile.push(s.dauerSek >= 60 && s.dauerSek % 60 === 0 ? `${s.dauerSek / 60} min` : `${s.dauerSek} s`);
  else if (s.wdh || s.wdhBis) teile.push(s.wdhBis && s.wdhBis !== s.wdh ? `${s.wdh ?? ''}–${s.wdhBis}` : `${s.wdh ?? s.wdhBis}`);
  if (s.gewicht) teile.push(`${s.gewicht.toLocaleString('de-DE')} kg`);
  return teile.join(' × ') || '–';
}

/** „4 × 8–12 × 60 kg“ oder bei verschiedenen Saetzen „3 Sätze: 10, 8, 6“. */
export function uebungKurz(pu: PlanUebung): string {
  const arbeit = pu.saetze.filter((s) => s.art !== 'aufwaermen');
  const auf = pu.saetze.length - arbeit.length;
  const texte = arbeit.map(satzText);
  const gleich = texte.every((t) => t === texte[0]);
  const kern = arbeit.length === 0 ? '' : gleich ? `${arbeit.length} × ${texte[0]}` : `${arbeit.length} Sätze: ${texte.join(', ')}`;
  return auf ? `${kern} (+${auf} Aufwärmen)` : kern;
}

export const pauseText = (sek?: number) => (sek === undefined ? '' : sek >= 60 ? `${Math.floor(sek / 60)}:${String(sek % 60).padStart(2, '0')} min` : `${sek} s`);

export const paceText = (sekProKm?: number) => (sekProKm ? `${Math.floor(sekProKm / 60)}:${String(Math.round(sekProKm % 60)).padStart(2, '0')} /km` : '');

/** „5:30“ -> 330 */
export function paceLesen(s: string): number | undefined {
  const m = /^(\d{1,2}):(\d{2})$/.exec(s.trim());
  return m ? Number(m[1]) * 60 + Number(m[2]) : undefined;
}

export const zahl1 = (v: number) => v.toLocaleString('de-DE', { maximumFractionDigits: 1 });
export const stunden = (min: number) => `${Math.floor(min / 60)}:${String(Math.round(min % 60)).padStart(2, '0')} h`;
